import { render, staticRenderFns } from "./AuthControlForm.vue?vue&type=template&id=46b60789&"
import script from "./AuthControlForm.vue?vue&type=script&lang=js&"
export * from "./AuthControlForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthControlForm.vue?vue&type=style&index=0&id=46b60789&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports